import { LoadableAfterPaint } from '@confluence/loadable';

export const ChangeboardingTargetLazyLoader = LoadableAfterPaint({
	loader: () =>
		import(/* webpackChunkName: "loadable-ChangeboardingTarget" */ './ChangeboardingTarget.js'),
});

export const ChangeboardingSpotlightLazyLoader = LoadableAfterPaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-ChangeboardingSpotlight" */ './ChangeboardingSpotlight.js'
		),
});
